import { Button } from "@material-ui/core";
import { toast } from "react-toastify";
import { avisoEmail, linkAbsoluto } from "../services/acesso";

export default function LinkGerado({ link, email, emailStatus }) {
    if (!link) return null;

    const absoluto = linkAbsoluto(link);
    const aviso = avisoEmail(emailStatus, email);

    const copiarPorSelecao = (texto) => {
        const area = document.createElement("textarea");
        area.value = texto;
        area.setAttribute("readonly", "");
        area.style.position = "fixed";
        area.style.top = "0";
        area.style.left = "0";
        area.style.opacity = "0";
        document.body.appendChild(area);
        area.focus();
        area.select();
        const ok = document.execCommand("copy");
        document.body.removeChild(area);
        if (!ok) {
            throw new Error("copy");
        }
    };

    const copiar = async () => {
        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(absoluto);
            } else {
                copiarPorSelecao(absoluto);
            }
            toast.success("Link copiado");
        } catch (e) {
            try {
                copiarPorSelecao(absoluto);
                toast.success("Link copiado");
            } catch (erro) {
                toast.error("Não foi possível copiar. Selecione o link e use Ctrl+C.");
            }
        }
    };

    return (
        <div style={{ marginTop: 12, padding: 12, background: "#f7f7f7", borderRadius: 4 }}>
            {aviso && <p style={{ color: aviso.cor, marginTop: 0 }}>{aviso.texto}</p>}
            <p style={{ wordBreak: "break-all", marginBottom: 8 }}>{absoluto}</p>
            <Button variant="outlined" type="button" onClick={copiar}>Copiar</Button>
        </div>
    );
}
